export default __webpack_public_path__ + "media/zurb/img/home/email-icon-d48453fab79ae0763b756e28f34b4236.svg";